import { axios } from '../../plugins/axios'

export default {
    namespaced: true,

    state: {
        municipios: [],
    },

    getters: {
        getMunicipios: state => {
            return state.municipios
        },
    },

    mutations: {
        SET_MUNICIPIOS(state, municipios) {
            state.municipios = municipios
        },
    },

    actions: {
        fetchMunicipios: async function({ commit }) {
            await axios
                .get('/EonCloud/municipios')
                .then(response => {
                    commit('SET_MUNICIPIOS', response.data.data)
                })
                .catch(error => console.log(error))
        },
    },
}
